module.exports = __webpack_public_path__ + "static/img/Circled Logo Large.d736f39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Circled Logo Large.png
// module id = 3BS8
// module chunks = 1